export default "__VITE_ASSET__Cg5PwKTz__"